import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import {
  AssociationType,
  fileAssociationType,
} from "@/shared/domain/association";

import { fileQueryKeys } from "./fileQueryKeys";

/**
 * The file extensions present in a directory, for the file type filter.
 * Resolves to an empty list, without a request, for an org, device or device
 * type folder: the service lists directory extensions for datasets only.
 */
export function useDirectoryExtensions(
  directoryPath: string,
  associationId: string,
  resourceOwnerId?: string,
) {
  const { files } = useDomainServices();

  return useQuery<string[], Error>({
    queryKey: fileQueryKeys.directoryExtensions({
      directoryPath,
      associationId,
    }),
    queryFn: async ({ signal }) => {
      if (fileAssociationType(associationId) !== AssociationType.Dataset) {
        return [];
      }

      const extensions = await files.getExtensionsForDirectory(
        associationId,
        directoryPath,
        {
          abortSignal: signal,
          resourceOwnerId,
        },
      );

      return extensions;
    },
  });
}
